document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mentor-swiper", {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
  jQuery(document).ready(function ($) {
    $(document).on("click", ".e-loop__load-more a", function () {
      var button = $(this);

      if (button.text().includes("Load")) {
        // store current position before load
        var currentScroll = $(window).scrollTop();

        setTimeout(function () {
          $("html, body").animate(
            {
              scrollTop: currentScroll + 400,
            },
            600,
          );
        }, 800);
      }
    });
  });
});
